// related to context/auth-context.tsx
import React, { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from 'context/auth-context';
import { routes } from 'router';

interface ProtectedRouteProps {
    children: ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
    const { isAuthenticated } = useAuth();
    const location = useLocation();

    return isAuthenticated ? (
        <>{children}</> // Render the child component if authenticated
    ) : (
        <Navigate to={routes.Login.path} replace state={{ from: location }} />
    );
};

export default ProtectedRoute;
